import { render, staticRenderFns } from "./ModifyFeedback.vue?vue&type=template&id=ecfbf174&scoped=true&"
import script from "./ModifyFeedback.vue?vue&type=script&lang=js&"
export * from "./ModifyFeedback.vue?vue&type=script&lang=js&"
import style0 from "./ModifyFeedback.vue?vue&type=style&index=0&id=ecfbf174&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecfbf174",
  null
  
)

export default component.exports